import { MenuItem } from 'primereact/menuitem'

type OptionalMenuItem = MenuItem | undefined

export default class MenuBuilder {
    private menuItems: MenuItem[] = []

    add(menuItem?: OptionalMenuItem): this {
        if (menuItem) this.menuItems.push(menuItem)
        return this
    }

    addIf(menuItem: OptionalMenuItem, condition: boolean = false): this {
        if (condition) return this.add(menuItem)
        return this
    }

    concat(menuItems?: MenuItem[]): this {
        if (menuItems) menuItems.forEach((menuItem) => this.add(menuItem))
        return this
    }

    concatIf(menuItems?: MenuItem[], condition: boolean = false): this {
        if (condition) return this.concat(menuItems)
        return this
    }

    toArray() {
        return this.menuItems
    }
}
